import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBrandConfiguration } from '@search/core/brands/context';
import { useSearchTitle } from '@search/core/hooks/useSearchTitle';
import { useAppContext } from '@search/serp_common/contexts/AppContext';
import { HeadInfosShell } from '@seo/head-infos';
import { GONE_410 } from '@/InnerApp';
export const AppWithProviders = ({ headInfosProps }) => {
    const { template: Template } = useBrandConfiguration();
    const [gone, searchModel, pageData, searchIndex, hubContent] = useAppContext((store) => [
        store.gone,
        store.searchModel,
        store.pageData,
        store.searchIndex,
        store.hubContent,
    ]);
    // The 410-page being very generic for now, it is displayed before templating.
    // Would be later moved to the template file if brand specific behaviors are needed.
    if (gone)
        return _jsx(_Fragment, { children: GONE_410 });
    const title = headInfosProps.title ?? useSearchTitle({ searchModel, pageData, updateTrigger: searchIndex, hubContent });
    return (_jsxs(_Fragment, { children: [_jsx(HeadInfosShell, { ...headInfosProps, title: title }), _jsx(Template, {})] }));
};
